import React from 'react'

export default function WassapButton() {
  return (
    <div className="footer-section whatsapp-section">
          <a
            href="https://wa.me/+573215886925"
            className="whatsapp-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp"></i>Chatea con nosotros en WhatsApp
          </a>
        </div>
  )
}
